module.exports = __webpack_public_path__ + "img/502.f330225d.jpg";